import React, { useMemo } from "react";
import {
  AppPage,
  MimaTable,
  MimaText,
  MimaOptionMenu,
  MimaButton,
} from "../../../components";
import moment from "moment";
import constant from "../../../utils/constant";
import { amountFormatter } from "../../../utils/utils";
import { AnimatePresence } from "framer-motion";
import {
  RefundP2PPaymentContainer,
  UpdateP2PPaymentContainer,
  UpdateP2PSellerPaymentContainer,
  VerifyP2PPaymentContainer,
  VerifyP2PSellerPaymentContainer,
  ViewMoreP2PInfoContainer,
} from "../../../containers";

const MoneyExP2POrders = ({
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  closeModal,
  singleItem,
  optionHandler,
  options,
  openModal,
  modalConstants,
  refetch,
}) => {
  const p2pOrdersTableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.moneyExOrders || [];
    }
    return [];
  }, [data]);

  const p2pOrdersTableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        return <span>{moment(date).format("DD/MM/YY HH:mm A")}</span>;
      },
    },
    // {
    //   Header: "Transaction Info",
    //   accessor: "from",
    //   Cell: ({ cell }) => {
    //     const from = cell.value;
    //     const to = cell.row.original.to;

    //     return (
    //       <div>
    //         <MimaText variant="small">Buyer receives {from}</MimaText>
    //         <MimaText variant="small">Seller receives {to}</MimaText>
    //       </div>
    //     );
    //   },
    // },
    {
      Header: "Buyer Details",
      accessor: "buyer",
      Cell: ({ cell }) => {
        const user = cell.value;
        const username = user.username;
        const fullname = `${user.firstname} ${user.lastname}`;
        const orders = user.orders;
        // const avgCompletionRate = user.avgCompletionRate;
        // const avgCompletionTime = user.avgCompletionTime;
        const row = cell.row.original;
        const buyerDebitValue = row.buyerDebitValue.amount;
        const currencyCode = row.buyerDebitValue.currencyCode;
        const formattedBuyerDebitValue =
          amountFormatter(currencyCode).format(buyerDebitValue);
        const buyerCreditValue = row.buyerCreditValue.amount;
        const creditCurrencyCode = row.from;
        const formattedBuyerCreditValue =
          amountFormatter(creditCurrencyCode).format(buyerCreditValue);

        const buyerStatus = row.buyerStatus;
        return (
          <div>
            <MimaText variant="smallBold">
              {fullname} - {username}
            </MimaText>
            <MimaText variant="small">{orders} orders</MimaText>
            {/* <div style={{ display: "flex", gap: "1rem" }}>
              <MimaText variant="small">{avgCompletionRate}% </MimaText>
              <MimaText variant="small">{avgCompletionTime}mins </MimaText>
            </div> */}

            <MimaText variant="small" mt={1}>
              Pays <span className="font__700">{formattedBuyerDebitValue}</span>
            </MimaText>
            <MimaText variant="small" mb={1}>
              Receives{" "}
              <span className="font__700">{formattedBuyerCreditValue}</span>
            </MimaText>

            <div
              className={`status  ${buyerStatus === "PAID" ? "status__green" : buyerStatus === "VALIDATION" ? "status__blue" : buyerStatus === "REVERSED" ? "status__grey" : buyerStatus === "FALSE-PAYMENT" ? "status__red" : "status__dark__yellow"}`}
            >
              {buyerStatus}
            </div>
          </div>
        );
      },
    },
    {
      Header: "Seller Details",
      accessor: "seller",
      Cell: ({ cell }) => {
        const user = cell.value;
        const username = user.username;
        const fullname = `${user.firstname} ${user.lastname}`;
        const orders = user.orders;
        // const avgCompletionRate = user.avgCompletionRate;
        // const avgCompletionTime = user.avgCompletionTime;

        const row = cell.row.original;

        const sellerCreditValue = row.sellerCreditValue.amount;
        const currencyCode = row.sellerCreditValue.currencyCode;
        const formattedSellerCreditValue =
          amountFormatter(currencyCode).format(sellerCreditValue);
        const sellerDebitValue = row.sellerDebitValue.amount;
        const debitCurrencyCode = row.sellerDebitValue.currencyCode;
        const formattedSellerDebitValue =
          amountFormatter(debitCurrencyCode).format(sellerDebitValue);

        const sellerStatus = row.sellerStatus;

        return (
          <div>
            <MimaText variant="smallBold">
              {fullname} - {username}
            </MimaText>
            <MimaText variant="small">{orders} orders</MimaText>
            {/* <div style={{ display: "flex", gap: "1rem" }}>
              <MimaText variant="small">{avgCompletionRate}% </MimaText>
              <MimaText variant="small">{avgCompletionTime}mins </MimaText>
            </div> */}

            <MimaText variant="small" mt={1}>
              Sells{" "}
              <span className="font__700">{formattedSellerDebitValue}</span>
            </MimaText>
            <MimaText variant="small" mb={1}>
              Receives{" "}
              <span className="font__700">{formattedSellerCreditValue}</span>
            </MimaText>

            <div
              className={`status  ${sellerStatus === "PAID" ? "status__green" : sellerStatus === "VALIDATION" ? "status__blue" : sellerStatus === "REVERSED" ? "status__grey" : sellerStatus === "FALSE-PAYMENT" ? "status__red" : "status__dark__yellow"}`}
            >
              {sellerStatus}
            </div>
          </div>
        );
      },
    },
    {
      Header: "Transaction Status",
      Cell: ({ cell }) => {
        const row = cell.row.original;
        const status = row.status;
        const adminBuyerPaymentStatus = row.adminBuyerPaymentStatus;
        const adminSellerPaymentStatus = row.adminSellerPaymentStatus;
        return (
          <div>
            <MimaText
              labelTitle="Admin - Buyer Payment Status"
              labelColor="var(--color-dark)"
            >
              <div
                className={`status  ${adminBuyerPaymentStatus === "PAID" ? "status__green" : adminBuyerPaymentStatus === "REVERSED" || adminBuyerPaymentStatus === "NO-RESPONSE-FROM-SELLER" ? "status__grey" : adminBuyerPaymentStatus === "FAILED" ? "status__red" : "status__dark__yellow"}`}
              >
                {adminBuyerPaymentStatus}
              </div>
            </MimaText>
            <MimaText
              labelTitle="Admin - Seller Payment Status"
              labelColor="var(--color-dark)"
            >
              <div
                className={`status  ${adminSellerPaymentStatus === "PAID" ? "status__green" : adminSellerPaymentStatus === "REVERSED" || adminSellerPaymentStatus === "NO-RESPONSE-FROM-SELLER" ? "status__grey" : adminSellerPaymentStatus === "FAILED" ? "status__red" : "status__dark__yellow"}`}
              >
                {adminSellerPaymentStatus}
              </div>
            </MimaText>
            <MimaText
              labelTitle="Transaction Complete Status"
              labelColor="var(--color-dark)"
            >
              <div
                className={`status  ${status === "COMPLETED" ? "status__green" : status === "REVERSED" || status === "NO-RESPONSE-FROM-SELLER" ? "status__grey" : status === "FAILED" ? "status__red" : "status__dark__yellow"}`}
              >
                {status}
              </div>
            </MimaText>
          </div>
        );
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        const buyerStatus = item?.buyerStatus;
        const sellerStatus = item?.sellerStatus;
        const adminBuyerPaymentStatus = item?.adminBuyerPaymentStatus;
        const adminSellerPaymentStatus = item?.adminSellerPaymentStatus;
        const status = item?.status;
        return (
          <MimaOptionMenu
            options={options(
              buyerStatus,
              sellerStatus,
              adminBuyerPaymentStatus,
              adminSellerPaymentStatus,
              status
            )}
            onOptionSelected={(option) => {
              optionHandler(option, item);
            }}
          />
        );
      },
    },
  ];
  return (
    <AppPage pageTitle="Money-Ex P2P Orders">
      <MimaButton
        title="Refresh Orders"
        onClick={refetch}
        mt={2}
        loading={isFetching}
      />
      <MimaTable
        tableData={p2pOrdersTableData}
        tableColumns={p2pOrdersTableColumns}
        searchPlaceholder="Search Money-Ex P2P Orders"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />

      {openModal !== modalConstants.Close && (
        <div className="modal">
          <AnimatePresence>
            {openModal === modalConstants.ViewMoreInfo && (
              <ViewMoreP2PInfoContainer
                closeModal={closeModal}
                singleItem={singleItem}
              />
            )}
            {openModal === modalConstants.VerifyBuyerPayment && (
              <VerifyP2PPaymentContainer
                closeModal={closeModal}
                singleItem={singleItem}
              />
            )}
            {openModal === modalConstants.VerifySellerPayment && (
              <VerifyP2PSellerPaymentContainer
                closeModal={closeModal}
                singleItem={singleItem}
              />
            )}
            {openModal === modalConstants.UpdateBuyerPayment && (
              <UpdateP2PPaymentContainer
                closeModal={closeModal}
                singleItem={singleItem}
              />
            )}
            {openModal === modalConstants.UpdateSellerPayment && (
              <UpdateP2PSellerPaymentContainer
                closeModal={closeModal}
                singleItem={singleItem}
              />
            )}
            {openModal === modalConstants.RefundBuyerPayment && (
              <RefundP2PPaymentContainer
                closeModal={closeModal}
                singleItem={singleItem}
              />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default MoneyExP2POrders;
